// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"2638de63","290":"6656bbca","716":"2bdecff5"}[chunkId] + ".chunk.js";
};